import React from 'react';
import { Box, Pagination } from '@mui/material';

const index = ({ totalPages, currentPage, onPageChange }) => {
  return (
    <Box display="flex" justifyContent="flex-start" alignItems="center" mt={2}>
      <Pagination
        count={totalPages}
        page={currentPage}
        onChange={onPageChange}
        sx={{
          '& .MuiPaginationItem-root': {
            backgroundColor: 'transparent',
            borderRadius: 0,
            color: 'black',
            '&:hover': {
              backgroundColor: 'transparent',
            },
            '&.Mui-selected': {
              backgroundColor: '#3bb77e',
              color: '#fff',
            },
          },
        }}
      />
    </Box>
  );
};

export default index;
